import { useQuery } from "@tanstack/react-query";
import {
  fetchRecentEnrollmentStatusChanges,
  type RecentEnrollmentStatusChangeDto,
} from "@/features/enrollments/shared/fetchRecentEnrollmentStatusChanges";
import { useAccessToken } from "@/hooks/shared";
import { RECENT_ENROLLMENTS_DAYS } from "@/lib/dashboard/recent-enrollments";
import { QueryKeys } from "@/lib/types";

export const recentEnrollmentStatusChangesQueryKey = [
  QueryKeys.ClassesEnrollmentsByStudentId,
  "recent-status-changes",
] as const;

export function useRecentEnrollmentStatusChanges(
  days = RECENT_ENROLLMENTS_DAYS,
  enabled = true,
) {
  const accessToken = useAccessToken();

  return useQuery<RecentEnrollmentStatusChangeDto[]>({
    queryKey: [...recentEnrollmentStatusChangesQueryKey, days],
    queryFn: () =>
      fetchRecentEnrollmentStatusChanges(accessToken!, days),
    enabled: enabled && !!accessToken,
    staleTime: 60_000,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
  });
}
